<div class="flex flex-wrap justify-between items-baseline gap-2">
  @switch (title?.type) {
    @case ('H1') {
      <h1 class="text-[16px] leading-[24px] text-[#162F4D] font-[700]">
        {{ title?.text }}
      </h1>
    }
    @default {
      <div class="text-[16px] leading-[24px] text-[#162F4D] font-[700]">
        {{ title?.text }}
      </div>
    }
  }
  <!-- @if (data?.renderableComponents.length > widgetAttributes.maxItemsPerRow) { -->
  <div class="flex gap-2 items-center">
    <div class="flex gap-2 mb-[10px]">
      <button
        (click)="scrollLeft()"
        class="md:w-8 md:h-8 w-6 h-6 border-[1px] border-solid border-[#d9d9d9] hover:border-[#ee5f00] transition rounded-[5px] flex items-center justify-center bg-transparent p-0 outline-none cursor-pointer bg-white"
      >
        <img
          src="https://static3.industrybuying.com/a-wk/images/svg/back-arrow.svg"
          height="14"
          width="12"
          alt="slide-previous"
          title="slide-previous"
        />
      </button>
      <button
        (click)="scrollRight()"
        class="md:w-8 md:h-8 w-6 h-6 border-[1px] border-solid border-[#d9d9d9] hover:border-[#ee5f00] transition rounded-[5px] flex items-center justify-center bg-transparent p-0 outline-none rotate-180 cursor-pointer bg-white"
      >
        <img
          src="https://static3.industrybuying.com/a-wk/images/svg/back-arrow.svg"
          height="14"
          width="12"
          alt="slide-next"
          title="slide-next"
        />
      </button>
    </div>
    <!-- <div
      routerLink="all-products"
      class="text-[16px] leading-[20px] text-[#F94D00] font-[300] sm:block hidden"
      >View all</div
    > -->
  </div>
  <!-- } -->
</div>

<div
  #widgetsContent
  class="w-full relative flex flex-nowrap whitespace-nowrap no-scrollbar"
>
  @for (product of data?.renderableComponents; track product; let i = $index) {
    <div
      class="flex-shrink-0 pl-[5px] first:pl-[0px]"
      [ngClass]="[
        cssClassMap.get(i),
        product?.value?.expandGrid
          ? 'w-[130px] md:w-[143px]'
          : 'w-[130px] md:w-[160px]'
      ]"
      [ngStyle]="cssStylesMap.get(i)"
    >
      <div class="h-full">
        <product-card
          [data]="product"
          [userContext]="userContextDto()"
          [actionEvent]="actionEvent"
        ></product-card>
      </div>
    </div>
  }
</div>
